
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27.53 23.57"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"chevrons-right"}},[_c('g',{attrs:{"id":"Path_358","data-name":"Path 358"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_1849","data-name":"Path 1849","d":"M12 1.29a1.75 1.75 0 011.24 3L5.73 11.8l7.52 7.52a1.75 1.75 0 01-2.47 2.47L2 13a1.74 1.74 0 010-2.48l8.78-8.72A1.72 1.72 0 0112 1.29z"}})]),_c('g',{attrs:{"id":"Path_359","data-name":"Path 359"}},[_c('path',{staticClass:"cls-1",attrs:{"id":"Path_1850","data-name":"Path 1850","d":"M24.27 1.29a1.75 1.75 0 011.24 3L18 11.8l7.52 7.52A1.75 1.75 0 0123 21.79L14.28 13a1.74 1.74 0 010-2.48L23 1.8a1.72 1.72 0 011.27-.51z"}})])])])
          )
        }
      }
    